exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-210702d3] {\n  position: relative;\n  font-size: 1rem;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n}\n.tooltip .tooltiptext[data-v-210702d3] {\n  visibility: hidden;\n  width: 250px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-weight: 400;\n  font-size: 1rem;\n  position: absolute;\n  z-index: 1000;\n  opacity: 0.8;\n  left: 100%;\n}\n.tooltip .tooltiptext.left[data-v-210702d3] {\n  left: auto;\n  right: 100%;\n}\n.tooltip:hover .tooltiptext[data-v-210702d3] {\n  visibility: visible;\n}", ""]);

// exports
